import React from "react";

interface IProps {
  text: string;
}
export const TierTitle = ({ text }: IProps) => {
  return <div className="cw-heading-2xl cw-text-center"> {text}</div>;
};
